import { Stack } from "@mui/material";
import { LocalizationProvider, TimePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { Controller } from "react-hook-form";

export default function WushTimeField({ formRegistration, control, defaultValue, label}) {
  console.log(formRegistration);
  return (
    <Stack>
      <Controller
        control={control}
        defaultValue={new Date(defaultValue)}
        name={formRegistration.name}
        render={({ field: { onChange, value, ref } }) => (
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <TimePicker label={label}
              onChange={onChange}
              onAccept={onChange}
              value={value}
              inputRef={ref}
              size="small"
            />
          </LocalizationProvider>
        )}
      />
    </Stack>
  );
}